import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import { routes as ouroborosRoutes } from './ouroboros/ouroboros.routes';


import { routes as appointmentRoutes } from './appointments/appointments.routes';
import { routes as agentisRoutes } from './agentis/agentis.routes';
import { routes as bulkMessageRoutes } from './bulkmessage/bulkmessage.routes';
import { routes as appointmentsProducts } from './products/products.routes';
import { routes as adsRoutes } from './ads/ads.routes';
import { routes as kanbanRoutes } from './kanban/kanban.routes';


export default {
  routes: [
    {
      path: '/app/',
      redirect: to => {
        // Redireciona para login se não estiver logado
        // O middleware de autenticação cuidará do resto
        return '/app/login';
      }
    },
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...appointmentRoutes, // Reponza
        ...agentisRoutes, // Reponza
        ...bulkMessageRoutes, // Reponza
        ...appointmentsProducts, // Reponza,
        ...adsRoutes, // Reponza
        ...kanbanRoutes, // Reponza
        ...searchRoutes,
        ...notificationRoutes,
        // Tire o comentario para voltar a rota ...ouroborosRoutes, // Reponza
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'manager', 'custom_role'],
      },
      component: Suspended,
    },
  ],
};
